import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "Slices/Response/responseSlice";
import { setToast, setLoading, setModal } from "Slices/uiSlice";
import { adminBloqueo, desactivarBloqueo, getBloqueos } from "Services/bloqueos_service";

const initialState = {
    bloqueos: [],
    bloqueo: {
        idBloqueo: 0,
        telefono: '',
        usuario: null,
    },
}

export const bloqueoSlice = createSlice({
    name: 'bloqueoCampanias',
    initialState,
    reducers: {
        setBloqueos: (state, action) => {
            state.bloqueos = action.payload;
        },
        setBloqueo: (state, action) => {
            state.bloqueo = action.payload ?? initialState.bloqueo;
        },
        updateBloqueoField: (state, action) => {
            const { name, value } = action.payload;
            state.bloqueo[name] = value;
        },
    }
});

export const fetchBloqueos = createAsyncThunk(
    'bloqueos/fetchBloqueos',
    async (_, { dispatch }) => {
        const bloqueosRes = await getBloqueos({canal: 'whatsapp'});
        dispatch(setBloqueos(bloqueosRes));
    }
);

export const mergeBloqueo = createAsyncThunk(
    'bloqueo/merge',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const bloqueoRes = await adminBloqueo(data);
        dispatch(setResponse(bloqueoRes));
        dispatch(setBloqueo(initialState.bloqueo));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchBloqueos());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const unlockBloqueo = createAsyncThunk(
    'bloqueo/unlock',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const bloqueoRes = await desactivarBloqueo(data);
        dispatch(setResponse(bloqueoRes));
        dispatch(setBloqueo(initialState.bloqueo));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchBloqueos());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setBloqueos, setBloqueo, updateBloqueoField } = bloqueoSlice.actions;
export default bloqueoSlice.reducer;